<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <search v-on:download="onDownload" v-on:searching="onSearch"></search>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="invoices"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">{{ props.item.invoiceNumber }}</td>
                  <td class="text-sm-left">
                    <v-switch
                      :key="props.item.id"
                      :readonly="props.item.delivered == 'YES' ? true : false"
                      :input-value="
                        props.item.delivered == 'YES' ? true : false
                      "
                      @change="saveDelivered(props.item, $event)"
                      hide-details
                      inset
                    ></v-switch>
                  </td>
                  <td class="text-sm-center">
                    <v-btn @click="handleDetails(props.item)" color="info"
                      >detalles</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-btn
                      v-if="!props.item.photoDelivered"
                      @click="handleAttachment(props.item)"
                      color="warning"
                      >adjunto</v-btn
                    >

                    <v-btn
                      v-if="props.item.photoDelivered"
                      @click="handleComment(props.item)"
                      color="error"
                      text
                      >ver adjunto</v-btn
                    >
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              @input="asyncPagination"
              :total-visible="7"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :item="detail.data"
        v-on:close-detail="detail.show = false"
      ></compose>
    </v-dialog>

    <v-dialog max-width="500" v-if="attachment.data" v-model="attachment.show">
      <attachment
        :item="attachment.data"
        :key="attachment.key"
        v-on:close-attach="attachment.show = false"
        v-on:save-attach="saveAttachment"
      ></attachment>
    </v-dialog>

    <v-dialog
      max-width="500"
      v-if="information.data"
      v-model="information.show"
    >
      <information
        :key="information.key"
        :item="information.data"
        v-on:close-information="information.show = false"
      ></information>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-snackbar v-model="snack.show" :timeout="3000" :color="snack.color">
      {{ snack.message }}
      <v-btn flat @click="snack.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import compose from './../dialog/DialogDetails'
import loading from './../dialog/DialogLoading'
import attachment from './../dialog/DialogAttachment'
import information from './../dialog/DialogInformation'
import message from './../dialog/Message'
import search from './Search.vue'
import SessionHelper from '@/helpers/SessionHelper'

export default {
  components: {
    compose,
    loading,
    attachment,
    information,
    message,
    search,
  },
  data() {
    return {
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      snack: {
        show: false,
        color: 'info',
        message: '',
      },
      detail: {
        show: null,
        data: null,
      },
      information: {
        show: null,
        data: null,
        key: 0,
      },
      dialog: {
        show: null,
        key: 0,
      },
      attachment: {
        show: null,
        data: null,
        key: 0,
      },
      complex: {
        headers: [
          {
            text: 'Facturas',
            sortable: false,
            value: 'invoiceNumber',
            align: 'left',
          },
          {
            text: 'Entregas',
            value: 'delivered',
            sortable: false,
          },
          {
            text: 'Detalles',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Recibido',
            sortable: false,
            align: 'center',
          },
        ],
      },
    }
  },

  created() {
    this.asyncPagination()
  },
  computed: {
    ...mapState({
      invoices: state => state.transit.deliver,
    }),
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'deliver',
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store.dispatch('transit/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            data: { ...row, products: items ? items : null },
            show: true,
          }
        })
    },
    handleAttachment(row) {
      this.attachment = {
        data: { invoices: row.id },
        show: true,
        key: this.attachment.key + 1,
      }
    },
    saveDelivered(row) {
      this.$store
        .dispatch('transit/delivered', { invoices: [row.id] })
        .then(() => {
          row.delivered = 'YES'
          this.snack = {
            show: true,
            color: 'success',
            message: 'Esta factura fue cambiada al estatus ENTREGADO.',
          }
        })
    },
    saveAttachment() {
      this.attachment.show = false
      this.loading = true
      this.asyncPagination().then(() => {
        this.dialog = {
          message: 'Adjunto agregado',
          show: true,
          key: this.dialog.key + 1,
        }
      })
    },
    handleComment(row) {
      this.information = {
        data: { type: 'payment', ...row },
        show: true,
        key: this.information + 1,
      }
    },
    onSearch(params) {
      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'deliver',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>
